<div class="shell">

  <!-- LEFT: Stage (narration) -->
  <section class="stage">
    <div class="stage-head">
      <ls-logo size="sm" [href]="'/' + lang()" />
      <div class="head-actions">
        <select class="lang-select" (change)="langService.switchLang($any($event.target).value)">
          @for (opt of langOptions; track opt.value) {
            <option [value]="opt.value" [selected]="opt.value === lang()">
              {{ opt.flag }} {{ opt.label }}
            </option>
          }
        </select>
        <a class="skip" [routerLink]="['/', lang()]">{{ 'ONBOARDING.SKIP' | translate }}</a>
      </div>
    </div>

    <div class="stage-body">

      <!-- Pane 1 -->
      <div class="pane-ed" [class.on]="currentStep() === 1">
        <div class="step-meta">
          <span class="dot"></span>
          <span class="step-num">{{ padStep() }} / 05</span>
          <span class="sep">—</span>
          <span class="step-name">{{ stepNameKey() | translate }}</span>
        </div>
        <h1>{{ 'ONBOARDING.P1.H1_1' | translate }}<br><em>{{ 'ONBOARDING.P1.H1_2' | translate }}</em></h1>
        <p class="lede" [innerHTML]="'ONBOARDING.P1.LEDE1' | translate"></p>
        <p class="lede" style="font-size:14px;color:var(--fg-mute);">{{ 'ONBOARDING.P1.LEDE2' | translate }}</p>
      </div>

      <!-- Pane 2 -->
      <div class="pane-ed" [class.on]="currentStep() === 2">
        <div class="step-meta">
          <span class="dot"></span>
          <span class="step-num">{{ padStep() }} / 05</span>
          <span class="sep">—</span>
          <span class="step-name">{{ stepNameKey() | translate }}</span>
        </div>
        <h1>{{ 'ONBOARDING.P2.H1_1' | translate }}<br><em>{{ 'ONBOARDING.P2.H1_2' | translate }}</em></h1>
        <p class="lede">{{ 'ONBOARDING.P2.LEDE' | translate }}</p>
        <div class="columns">
          <div class="col">
            <strong>{{ 'ONBOARDING.P2.COL1_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P2.COL1_DESC' | translate }}</p>
          </div>
          <div class="col">
            <strong>{{ 'ONBOARDING.P2.COL2_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P2.COL2_DESC' | translate }}</p>
          </div>
        </div>
        <a class="deep-link" [routerLink]="['/', lang(), 'Discover']">{{ 'ONBOARDING.P2.LINK' | translate }}</a>
      </div>

      <!-- Pane 3 -->
      <div class="pane-ed" [class.on]="currentStep() === 3">
        <div class="step-meta">
          <span class="dot"></span>
          <span class="step-num">{{ padStep() }} / 05</span>
          <span class="sep">—</span>
          <span class="step-name">{{ stepNameKey() | translate }}</span>
        </div>
        <h1>{{ 'ONBOARDING.P3.H1_1' | translate }}<br><em>{{ 'ONBOARDING.P3.H1_2' | translate }}</em></h1>
        <p class="lede">{{ 'ONBOARDING.P3.LEDE' | translate }}</p>
        <div class="columns">
          <div class="col">
            <strong>{{ 'ONBOARDING.P3.COL1_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P3.COL1_DESC' | translate }}</p>
          </div>
          <div class="col">
            <strong>{{ 'ONBOARDING.P3.COL2_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P3.COL2_DESC' | translate }}</p>
          </div>
        </div>
        <a class="deep-link" [routerLink]="['/', lang(), 'premium']">{{ 'ONBOARDING.P3.LINK' | translate }}</a>
      </div>

      <!-- Pane 4 -->
      <div class="pane-ed" [class.on]="currentStep() === 4">
        <div class="step-meta">
          <span class="dot"></span>
          <span class="step-num">{{ padStep() }} / 05</span>
          <span class="sep">—</span>
          <span class="step-name">{{ stepNameKey() | translate }}</span>
        </div>
        <h1>{{ 'ONBOARDING.P4.H1_1' | translate }}<br><em>{{ 'ONBOARDING.P4.H1_2' | translate }}</em></h1>
        <p class="lede">{{ 'ONBOARDING.P4.LEDE' | translate }}</p>
        <div class="columns">
          <div class="col">
            <strong>{{ 'ONBOARDING.P4.COL1_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P4.COL1_DESC' | translate }}</p>
          </div>
          <div class="col">
            <strong>{{ 'ONBOARDING.P4.COL2_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P4.COL2_DESC' | translate }}</p>
          </div>
        </div>
        <a class="deep-link" [routerLink]="['/', lang(), 'Discover']">{{ 'ONBOARDING.P4.LINK' | translate }}</a>
      </div>

      <!-- Pane 5 -->
      <div class="pane-ed" [class.on]="currentStep() === 5">
        <div class="step-meta">
          <span class="dot"></span>
          <span class="step-num">{{ padStep() }} / 05</span>
          <span class="sep">—</span>
          <span class="step-name">{{ stepNameKey() | translate }}</span>
        </div>
        <h1>{{ 'ONBOARDING.P5.H1_1' | translate }}<br><em>{{ 'ONBOARDING.P5.H1_2' | translate }}</em></h1>
        <p class="lede" [innerHTML]="'ONBOARDING.P5.LEDE' | translate"></p>
        <div class="columns">
          <div class="col">
            <strong>{{ 'ONBOARDING.P5.COL1_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P5.COL1_DESC' | translate }}</p>
          </div>
          <div class="col">
            <strong>{{ 'ONBOARDING.P5.COL2_TITLE' | translate }}</strong>
            <p>{{ 'ONBOARDING.P5.COL2_DESC' | translate }}</p>
          </div>
        </div>
      </div>

    </div>

    <div class="stage-foot">
      <button class="btn-prev" type="button" (click)="goPrev()" [attr.aria-disabled]="currentStep() === 1">{{ 'ONBOARDING.PREV' | translate }}</button>
      <div class="progress" role="progressbar" [attr.aria-valuenow]="currentStep()" aria-valuemin="1" [attr.aria-valuemax]="totalSteps">
        @for (seg of stepSegments(); track seg) {
          <span class="seg" [class.done]="seg < currentStep()" [class.cur]="seg === currentStep()"></span>
        }
      </div>
      @if (currentStep() < totalSteps) {
        <button class="btn-next" type="button" (click)="goNext()">{{ 'ONBOARDING.NEXT' | translate }}</button>
      } @else {
        <button class="btn-end" type="button" (click)="finish()">{{ 'ONBOARDING.FINISH' | translate }}</button>
      }
    </div>
  </section>

  <!-- RIGHT: Plate-side (mockups) -->
  <section class="plate-side">

    <div class="plate-body">

      <!-- Mockup 1: Library -->
      <div class="pane-pl" [class.on]="currentStep() === 1">
        <div class="mock-lib">
          <div class="line now">
            <div class="art a1"></div>
            <div class="body">
              <div class="ti">Mèsi Senyè</div>
              <div class="me">Marie-Jean · MJF 124</div>
            </div>
            <span class="tag audio">audio</span>
          </div>
          <div class="line">
            <div class="art a2"></div>
            <div class="body">
              <div class="ti">Tu es digne, Seigneur</div>
              <div class="me">Hillsong FR · JEM 318</div>
            </div>
            <span class="tag audio">audio</span>
          </div>
          <div class="line">
            <div class="art lyric"></div>
            <div class="body">
              <div class="ti">Quel ami fidèle</div>
              <div class="me">J. Scriven · CE 114</div>
            </div>
            <span class="tag">paroles</span>
          </div>
          <div class="line">
            <div class="art a3"></div>
            <div class="body">
              <div class="ti">Au pied de la croix</div>
              <div class="me">Hillsong FR · single</div>
            </div>
            <span class="tag audio">audio</span>
          </div>
          <div class="line">
            <div class="art lyric"></div>
            <div class="body">
              <div class="ti">À toi la gloire</div>
              <div class="me">CEF 134 · domaine public</div>
            </div>
            <span class="tag">paroles</span>
          </div>
        </div>
        <p class="plate-caption">
          <b>{{ 'ONBOARDING.P1.CAPTION_TITLE' | translate }}</b>
          {{ 'ONBOARDING.P1.CAPTION' | translate }}
        </p>
      </div>

      <!-- Mockup 2: Reader -->
      <div class="pane-pl" [class.on]="currentStep() === 2">
        <div class="mock-reader">
          <div class="head">
            <div class="ti">Mèsi Senyè</div>
            <div class="key">D</div>
          </div>
          <div class="lyrics">
            <span class="chord">D — A</span>
            Lè m konsidere tout sa ou fè
            <span class="chord">G — D</span>
            m pa ka fè <span class="lh">mwen di anyen</span>
            <span class="chord">D — Bm</span>
            <span class="now">Mèsi Senyè, mèsi anpil</span>
            <span class="chord">G — A</span>
            pou tout sa ou ban nou
          </div>
        </div>
        <p class="plate-caption">
          <b>{{ 'ONBOARDING.P2.CAPTION_TITLE' | translate }}</b>
          {{ 'ONBOARDING.P2.CAPTION' | translate }}
        </p>
      </div>

      <!-- Mockup 3: Projection -->
      <div class="pane-pl" [class.on]="currentStep() === 3">
        <div class="mock-projection">
          <div class="head">
            <span>MJF 124 · Refrain</span>
            <span>Krèyol</span>
          </div>
          <div class="body">Mèsi Senyè, mèsi anpil<br/>pou tout sa ou ban nou</div>
          <div class="foot">
            <span>4 / 11</span>
            <span>auto · 8s</span>
          </div>
          <div class="glow"></div>
        </div>
        <p class="plate-caption">
          <b>{{ 'ONBOARDING.P3.CAPTION_TITLE' | translate }}</b>
          {{ 'ONBOARDING.P3.CAPTION' | translate }}
        </p>
      </div>

      <!-- Mockup 4: Form -->
      <div class="pane-pl" [class.on]="currentStep() === 4">
        <div class="mock-form">
          <div class="form-h">
            <span>Nouveau chant</span>
            <span class="status">brouillon · 2 min</span>
          </div>
          <div class="field-label">Titre</div>
          <div class="input focused">Mèsi Senyè</div>
          <div class="row">
            <div>
              <div class="field-label">Recueil</div>
              <div class="input">MJF</div>
            </div>
            <div>
              <div class="field-label">N°</div>
              <div class="input">124</div>
            </div>
          </div>
          <div class="field-label">Paroles · couplet 1</div>
          <div class="ta">Lè m konsidere tout sa ou fè<br/>m pa ka fè mwen di anyen…</div>
          <div class="row">
            <div>
              <div class="field-label">Tonalité</div>
              <div class="input">D maj.</div>
            </div>
            <div>
              <div class="field-label">Langue</div>
              <div class="input">Krèyol</div>
            </div>
          </div>
        </div>
        <p class="plate-caption">
          <b>{{ 'ONBOARDING.P4.CAPTION_TITLE' | translate }}</b>
          {{ 'ONBOARDING.P4.CAPTION' | translate }}
        </p>
      </div>

      <!-- Mockup 5: Checklist -->
      <div class="pane-pl" [class.on]="currentStep() === 5">
        <div class="mock-checklist">
          <div class="item">
            <span class="num">01</span>
            <div class="body">
              <div class="ti">Ouvre un premier chant.</div>
              <div class="desc">essaye « Mèsi Senyè » — c'est le chant le plus écouté du mois</div>
            </div>
          </div>
          <div class="item">
            <span class="num">02</span>
            <div class="body">
              <div class="ti">Ajoute-le aux favoris.</div>
              <div class="desc">cœur en haut à droite — il rejoindra ta bibliothèque</div>
            </div>
          </div>
          <div class="item">
            <span class="num">03</span>
            <div class="body">
              <div class="ti">Crée une playlist.</div>
              <div class="desc">depuis bibliothèque → playlists → nouvelle</div>
            </div>
          </div>
        </div>
        <p class="plate-caption">
          <b>{{ 'ONBOARDING.P5.CAPTION_TITLE' | translate }}</b>
          {{ 'ONBOARDING.P5.CAPTION' | translate }}
        </p>
      </div>

    </div>

    <footer class="plate-foot">
      <span><kbd>←</kbd><kbd>→</kbd> {{ 'ONBOARDING.FOOTER_NAV' | translate }}</span>
      <span>{{ 'ONBOARDING.FOOTER_VERSION' | translate }}</span>
    </footer>
  </section>

</div>
